<div
        [formGroup]="objectForm"
        class="object-info"
>
    <div
            *ngIf="!isFullScreenCalculator"
            class="object-info__main"
    >
        <ng-container *ngIf="isLinkObject">

            <div
                    [formGroup]="linkForm"
                    class="input-group"
            >

                <lta-input
                        [isLoading]="isLoading"
                        formControlName="name"
                        label="{{ 'lta.name' | translate }}"
                />
                <lta-input
                        *ngIf="linkObject?.id"
                        [copy]="true"
                        [disabled]="true"
                        [isLoading]="isLoading"
                        [value]="linkObject.id"
                        label="{{ 'lta.objectId' | translate }}"
                />
                <lta-select
                        [clipboardContent]="linkObject.model.id"
                        [copy]="true"
                        [isLoading]="isLoading"
                        [selectOptions]="modelsSelectOptions"
                        formControlName="modelId"
                        label="{{ 'lta.model' | translate }}"
                />
                <lta-textarea
                        [isLoading]="isLoading"
                        formControlName="description"
                        label="{{ 'lta.description' | translate }}"
                        rows="2"
                />
            </div>
            <lta-sep />
            <div
                    class="section-name"
            >{{ 'lta.object' | translate }}
            </div>
            <lta-btn
                    (onClick)="onAddLink.emit(linkObject)"
                    *ngIf="!linkObject.origin_object"
                    [style.width]="'100%'"
                    size="md"
                    theme="dashed"
            >
                <div class="btn-icon-container">
                    <lta-svg-icon
                            icon="reference"
                            size="20"
                    />
                    <span>{{ 'lta.bindObject' | translate }}</span>
                </div>
            </lta-btn>

            <lta-btn
                    (onClick)="onRemoveLink.emit(linkObject)"
                    *ngIf="linkObject.origin_object"
                    [style.margin-bottom]="'20px'"
                    [style.width]="'100%'"
                    size="md"
                    theme="danger"
            >
                <div class="btn-icon-container">
                    <lta-svg-icon
                            icon="unlink"
                            size="20"
                    />
                    <span>{{ 'lta.unbind' | translate }}</span>
                </div>
            </lta-btn>

        </ng-container>
        <form
                *ngIf="!isLinkObject || linkObject.origin_object"
                class="input-group"
        >
            <lta-input
                    [isLoading]="isLoading"
                    formControlName="name"
                    label="{{ 'lta.name' | translate }}"
            />
            <lta-input
                    *ngIf="activeObject?.id"
                    [copy]="true"
                    [disabled]="true"
                    [isLoading]="isLoading"
                    [value]="activeObject.id"
                    label="{{ 'lta.objectId' | translate }}"
            />
            <lta-textarea
                    [isLoading]="isLoading"
                    formControlName="description"
                    label="{{ 'lta.description' | translate }}"
                    rows="2"
            />
            <lta-select
                    [clipboardContent]="modelForm.value"
                    [copy]="true"
                    [formControl]="modelForm"
                    [isLoading]="isLoading"
                    [selectOptions]="modelsSelectOptions"
                    label="{{ 'lta.model' | translate }}"
            />
            <lta-input
                    [isLoading]="isLoading"
                    formControlName="unit"
                    label="{{ 'lta.unit' | translate }}"
            />
            <div class="value">
                <lta-input
                        #input
                        *ngIf="hasValue && !isEditValue"
                        [copy]="input.disabled"
                        [disabled]="true"
                        [isLoading]="isLoading"
                        [unreliable]="websocketValue?.isReliable"
                        [value]="websocketValue?.value"
                        label="{{ 'lta.value' | translate }}"
                />
                <lta-input
                        #input
                        *ngIf="isEditValue && isModelFloat"
                        [copy]="input.disabled"
                        [formControl]="valueForm"
                        [isLoading]="isLoadingValue"
                        [type]="'number'"
                        label="{{ 'lta.value' | translate }}"
                />
                <lta-input
                        #input
                        *ngIf="isEditValue && isModelInteger"
                        [copy]="input.disabled"
                        [formControl]="valueForm"
                        [isLoading]="isLoadingValue"
                        [type]="'number'"
                        label="{{ 'lta.value' | translate }}"
                />
                <lta-select
                        #input
                        *ngIf="isEditValue && isModelBool"
                        [copy]="input.disabled"
                        [formControl]="valueForm"
                        [isLoading]="isLoadingValue"
                        [selectOptions]="fixBooleanSelectOptions"
                        label="{{ 'lta.value' | translate }}"
                        position="dynamic"
                />
                <lta-input
                        #input
                        *ngIf="isEditValue && isModelString"
                        [copy]="input.disabled"
                        [formControl]="valueForm"
                        [isLoading]="isLoadingValue"
                        label="{{ 'lta.value' | translate }}"
                />
                <div
                        (click)="changeValue()"
                        *ngIf="hasValue"
                        [class.disabled]="valueForm.pristine && isEditValue"
                        class="edit-value"
                >
                    <span *ngIf="!isEditValue">{{ 'lta.editValue' | translate }}</span>
                    <span
                            (click)="saveValue(); $event.stopPropagation()"
                            *ngIf="isEditValue"
                    >
                        {{ 'lta.saveValue' | translate }}
                    </span>
                </div>
            </div>
        </form>
        <ng-container *ngIf="eventsAvailable">
            <lta-sep />
            <form
                    class="input-group"
                    formGroupName="event_settings"
            >
                <div class="switch">
                    <span>{{ 'lta.eventsSet' | translate }}</span>
                    <lta-switch
                            [isLoading]="isLoading"
                            [skipAnimation]="skipSwitching"
                            formControlName="enabled"
                    />
                </div>
                <div [hidden]="!eventSettingsSwitch.value">
                    <lta-select
                            [disabled]="!eventSettingsSwitch.value"
                            [isLoading]="isLoading"
                            [selectOptions]="eventSetsSelectOptions"
                            [withCancel]="true"
                            formControlName="event_settings_set_id"
                            label="{{ 'lta-event-sets.name' | translate }}"
                            position="dynamic"
                    />
                </div>
                <lta-spoiler-panel
                        *ngIf="eventSettingsStatuses.length > 0"
                        [isOpen]="eventSettingsStatuses.length > 0"
                        class="settings-spoiler"
                        theme="smooth"
                >
                    <span class="title">{{ 'lta-event-sets.statusesArr' | translate }}</span>
                    <div class="statuses">
                        <lta-event-status-for-object
                                (onChange)="updatePersonalEventSettingsStatus(i, $event)"
                                (onDelete)="deletePersonalEventSettingsStatus(i)"
                                *ngFor="let status of eventSettingsStatuses; index as i"
                                [data]="status"
                                [isValueUnique]="checkIsUniqueStatus(i)"
                                [modelType]="activeObject.model.id"
                                [readonly]="eventSettingsSwitch.value"
                        />
                        <lta-btn
                                (onClick)="addPersonalEventSettingsStatus()"
                                *ngIf="showAddSettingsStatusBtn"
                                class="add-status-btn"
                                size="block"
                                theme="dashed"
                        >
                            <lta-svg-icon
                                    class="icon"
                                    icon="plus"
                                    size="20"
                            />&nbsp;
                            {{ 'lta-event-sets.addStatus' | translate }}
                        </lta-btn>
                    </div>
                </lta-spoiler-panel>
                <lta-btn
                        (onClick)="addPersonalEventSettingsStatus()"
                        *ngIf="showAddSettingsStatusBtn && eventSettingsStatuses.length == 0"
                        class="add-status-btn"
                        size="block"
                        theme="dashed"
                >
                    <lta-svg-icon
                            class="icon"
                            icon="plus"
                            size="20"
                    />&nbsp;
                    {{ 'lta-event-sets.addStatus' | translate }}
                </lta-btn>
            </form>
        </ng-container>
        <ng-container
                *ngIf="driverAvailable"
                formGroupName="driver_settings"
        >
            <lta-sep />
            <div
                    [allowed]="!driverWriteFlag.value && imitationSettingsSwitch.value || calculateSettingsSwitch.value"
                    [delay]="700"
                    [lta-tooltip]="'lta.switchOfDataSourceDescription' | translate"
                    [position]="'top-left'"
                    [textEllipsis]="false"
                    [tooltipClasses]="['object-info__tooltip']"
                    [width]="'260px'"
                    class="switch"
                    position="left"
            >
                <span>{{ 'lta.connectToDriver' | translate }}</span>
                <lta-switch
                        [isLoading]="isLoading"
                        [skipAnimation]="skipSwitching"
                        formControlName="enabled"
                >
                    <div class="modal">
                        <span>{{ 'lta.period_s' | translate }}:</span>
                        <span>{{ 'lta.period_sDescription' | translate }}</span>
                    </div>
                </lta-switch>
            </div>
            <div
                    [hidden]="!driverSettingsSwitch.value"
                    formGroupName="settings"
            >
                <form class="input-group">
                    <lta-select
                            [isLoading]="isLoading"
                            [selectOptions]="driversSelectOptions"
                            [topGap]="58"
                            formControlName="id"
                            label="{{ 'lta.driver' | translate }}"
                            placeholder="{{ 'lta.selectDriver' | translate }}"
                            position="dynamic"
                    />
                    <div
                            [hidden]="!driverSettingsDriverId"
                            class="driver-id"
                    >
                        <lta-driver-element-select
                                (onUnselectDriverElement)="onUnselectDriverElement()"
                                [disabledBtns]="updateInProgress"
                                [driverId]="driverSettingsDriverId"
                                formControlName="driver_object_id"
                        />
                        <lta-select

                                [isLoading]="isLoading"
                                [selectOptions]="readFlagsSelectOptions"
                                formControlName="write_flag"
                                label="{{ 'lta.flag' | translate }}"
                                placeholder="{{ 'lta.selectFlag' | translate }}"
                                position="dynamic"
                        />
                    </div>
                </form>
            </div>
        </ng-container>
        <ng-container
                *ngIf="imitationAvailable"
                formGroupName="imitation_settings"
        >
            <lta-sep />
            <div
                    [allowed]="!driverWriteFlag.value && driverSettingsSwitch.value || calculateSettingsSwitch.value"
                    [delay]="700"
                    [lta-tooltip]="'lta.switchOfDataSourceDescription' | translate"
                    [position]="'top-left'"
                    [textEllipsis]="false"
                    [tooltipClasses]="['object-info__tooltip']"
                    [width]="'260px'"
                    class="switch"
                    position="left"
            >
                <span>{{ 'lta.imitation' | translate }}</span>
                <lta-switch
                        [isLoading]="isLoading"
                        [skipAnimation]="skipSwitching"
                        formControlName="enabled"
                />
            </div>
            <form
                    class="input-group"
                    formGroupName="settings"
            >
                <div [hidden]="!imitationSettingsSwitch.value">
                    <lta-select
                            [isLoading]="isLoading"
                            [selectOptions]="imitationTypes"
                            [withCancel]="true"
                            formControlName="type"
                            label="{{ 'lta.type' | translate }}"
                            position="dynamic"
                    />
                </div>
                <div [hidden]="!((highImitationComplexity || randomImitationComplexity)  && imitationSettingsSwitch.value)">
                    <lta-input
                            [isLoading]="isLoading"
                            [tooltip]="highImitationComplexity"
                            [type]="'number'"
                            formControlName="period_s"
                            label="{{ (highImitationComplexity ? 'lta.period_s' : 'lta.minValue') | translate }}"
                    >
                        <div
                                *ngIf="highImitationComplexity"
                                class="modal"
                        >
                            <span>{{ 'lta.period_s' | translate }}:</span>
                            <span>{{ 'lta.period_sDescription' | translate }}</span>
                        </div>

                    </lta-input>
                </div>
                <div [hidden]="!(highImitationComplexity && imitationSettingsSwitch.value)">
                    <lta-input
                            [isLoading]="isLoading"
                            [tooltip]="true"
                            [type]="'number'"
                            formControlName="amplitude"
                            label="{{ 'lta.amplitude' | translate }}"
                    >
                        <div class="modal">
                            <span>{{ 'lta.amplitude' | translate }}:</span>
                            <span>{{ 'lta.amplitudeDescription' | translate }}</span>
                        </div>
                    </lta-input>
                </div>
                <div [hidden]="!((lowImitationComplexity || mediumImitationComplexity || highImitationComplexity || randomImitationComplexity) && imitationSettingsSwitch.value)">
                    <lta-input
                            [isLoading]="isLoading"
                            [tooltip]="true"
                            [type]="'number'"
                            formControlName="discrete_ms"
                            label="{{ 'lta.discrete_ms' | translate }}"
                    >
                        <div class="modal">
                            <span>{{ 'lta.discrete_ms' | translate }}:</span>
                            <span>{{ 'lta.discrete_msDescription' | translate }}</span>
                        </div>
                    </lta-input>
                </div>
                <div [hidden]="!((mediumImitationComplexity || highImitationComplexity || randomImitationComplexity) && imitationSettingsSwitch.value)">
                    <lta-input
                            *ngIf="imitationType !== 2"
                            [isLoading]="isLoading"
                            [tooltip]="highImitationComplexity || mediumImitationComplexity"
                            [type]="'number'"
                            formControlName="shift"
                            label="{{(highImitationComplexity ? 'lta.shift' : mediumImitationComplexity ? 'lta.value' : 'lta.maxValue') | translate}}"
                    >
                        <div class="modal">
                            <span>{{ (highImitationComplexity ? 'lta.shift' : 'lta.value') | translate }}:</span>
                            <span>{{ (highImitationComplexity ? 'lta.shiftDescription' : 'lta.valueDescription') | translate }}</span>
                        </div>
                    </lta-input>
                    <lta-select
                            *ngIf="imitationType === 2"
                            [isLoading]="isLoading"
                            [selectOptions]="fixBooleanSelectOptions"
                            formControlName="shift"
                            label="{{((highImitationComplexity || randomImitationComplexity) ? 'lta.shift' : 'lta.value') | translate}}"
                            position="dynamic"
                    >
                        <div class="modal">
                            <span>{{ (highImitationComplexity ? 'lta.shift' : 'lta.value') | translate }}:</span>
                            <span>{{ (highImitationComplexity ? 'lta.shiftDescription' : 'lta.valueDescription') | translate }}</span>
                        </div>
                    </lta-select>
                </div>
                <div [hidden]="!(highImitationComplexity && imitationSettingsSwitch.value)">
                    <lta-input
                            [isLoading]="isLoading"
                            [tooltip]="true"
                            [type]="'number'"
                            formControlName="start_phase"
                            label="{{ 'lta.startPhase' | translate }}"
                    >
                        <div class="modal">
                            <span>{{ 'lta.startPhase' | translate }}:</span>
                            <span>{{ 'lta.startPhaseDescription' | translate }}</span>
                        </div>
                    </lta-input>
                </div>
            </form>
        </ng-container>
        <ng-container *ngIf="calculationAvailable">
            <lta-sep />
            <form
                    class="input-group"
                    formGroupName="calculate_settings"
            >
                <div
                        [allowed]="!driverWriteFlag.value && driverSettingsSwitch.value || imitationSettingsSwitch.value"
                        [delay]="700"
                        [lta-tooltip]="'lta.switchOfDataSourceDescription' | translate"
                        [position]="'top-left'"
                        [textEllipsis]="false"
                        [tooltipClasses]="['object-info__tooltip']"
                        [width]="'260px'"
                        class="switch"
                        position="left"
                >
                    <span>{{ 'lta.calculation' | translate }}</span>
                    <lta-switch
                            [isLoading]="isLoading"
                            [skipAnimation]="skipSwitching"
                            formControlName="enabled"
                    />
                </div>
                <div [hidden]="!calculateSettingsSwitch.value">
                    <lta-formula-input
                            (onBlur)="showFormulaSelect.emit(false)"
                            (onFocus)="showFormulaSelect.emit(true)"
                            (onFullScreen)="toggleFullScreenCalculator(true)"
                            [isFullScreen]="isFullScreenCalculator"
                            formControlName="formula"
                    />
                </div>
            </form>
        </ng-container>
    </div>
    <div
            *ngIf="isFullScreenCalculator"
            class="fullscreen-calculator"
            formGroupName="calculate_settings"
    >
        <div class="fullscreen-calculator__header">
            <lta-back-btn (onBack)="toggleFullScreenCalculator(false)" />
            <div>{{ 'lta-object.backToObjectSettings' | translate }}</div>
        </div>
        <lta-formula-input
                (onBlur)="showFormulaSelect.emit(false)"
                (onFocus)="showFormulaSelect.emit(true)"
                [isFullScreen]="isFullScreenCalculator"
                class="fullscreen-calculator__input"
                formControlName="formula"
        />
    </div>
    <lta-save-cancel-panel
            (onCancel)="onCancel()"
            (onSave)="onSave()"
            *ngIf="activeObject || linkObject"
            [saveDisabled]="saveDisabled"
            [state]="saveState"
            btnPosition="right"
            class="bottom-actions"
    />
</div>
